// extracted by mini-css-extract-plugin
export default {"tableSkeleton":"TableSkeleton_tableSkeleton__r7v8k","tableBody":"TableSkeleton_tableBody__11fTB"};